import script from "./noticelist.vue?vue&type=script&lang=ts&setup=true"
export * from "./noticelist.vue?vue&type=script&lang=ts&setup=true"

import "./noticelist.vue?vue&type=style&index=0&id=57c11e0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57c11e0e"]])

export default __exports__